import type { CartProduct } from "@/contexts/CartContext";

export type ZemelapisTier = "single" | "gift_pair" | "gift_single" | "karjera" | "karjera_gift";

export interface ZemelapisTierInfo {
  tier: ZemelapisTier;
  /** Short label shown in the compact rows */
  label: string;
  /** Full product title used in checkout */
  title: string;
  price: number;
  id: string;
  best?: boolean;
}

export const ZEMELAPIS_TIERS: ZemelapisTierInfo[] = [
  { tier: "single", label: "Sau", title: "Žemėlapis — vienam", price: 19.9, id: "zemelapis-single" },
  { tier: "gift_pair", label: "Sau + artimam", title: "Žemėlapis — sau ir artimam", price: 29.9, id: "zemelapis-gift-pair", best: true },
  { tier: "gift_single", label: "Dovana", title: "Žemėlapis — dovana", price: 19.9, id: "zemelapis-gift-single" },
];

export const KARJERA_ZEMELAPIS: ZemelapisTierInfo = {
  tier: "karjera",
  label: "Karjera",
  title: "Karjeros žemėlapis",
  price: 24.9,
  id: "karjeros-zemelapis",
};

const ALL_ZEMELAPIS_PRODUCTS: ZemelapisTierInfo[] = [
  ...ZEMELAPIS_TIERS,
  KARJERA_ZEMELAPIS,
  { tier: "karjera_gift", label: "Karjera", title: "Karjeros žemėlapis", price: 24.9, id: "karjeros-zemelapis" },
];

export interface ZemelapisGiftFields {
  senderName?: string;
  recipientName?: string;
  recipientEmail?: string;
  message?: string;
}

/** Builds the single cart product for an express (one-item) Žemėlapis checkout. */
export function zemelapisProduct(tier: ZemelapisTier, gift?: ZemelapisGiftFields): CartProduct {
  const info = ALL_ZEMELAPIS_PRODUCTS.find((t) => t.tier === tier) ?? ZEMELAPIS_TIERS[0];
  return {
    id: info.id,
    title: info.title,
    price: info.price,
    cover_url: null,
    type: "zemelapis",
    zemelapisTier: info.tier,
    giftSenderName: gift?.senderName,
    giftRecipientName: gift?.recipientName,
    giftRecipientEmail: gift?.recipientEmail,
    giftMessage: gift?.message,
  };
}
